<template>
  <div class="media-dialog" v-if="isVisible" v-loading="isBusy">
    <div class="media-dialog__header">
      <button @click="close" class="border-0 bg-transparent">
        <i class="fas fa-2x fa-times"></i>
      </button>
    </div>
    <div class="media-dialog__body">
      <div class="wh-100 d-flex flex-column">
        <div class="flex-grow-1 position-relative text-center">
            <img :src="getSrc" style="max-width: 250px" />
        </div>
        <div class="flex-grow-1 position-relative text-center mt-5">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item prop="name">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="media-dialog__footer text-center">
      <div class="media-dialog__footer text-center">
        <button type="button" class="btn btn-primary" @click="onStore">
          Store
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatorMixin from "../../mixins/validator";

export default {

  data() {
    const form = {
      name: null,
    };

    return {
      form,
      isVisible: false,
      isBusy: false,
      storeUrl: null,
      model: null,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    };
  },

  computed: {
    /**
     * @return {String}
     */
    getSrc() {
      return _.get(this.model, 'full_url');
    },
  },

  methods: {
    /**
     * @param model
     * @param storeUrl
     */
    show({model, storeUrl}) {
      this.isVisible = true;
      this.storeUrl = storeUrl;
      this.model = model;

      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },

    /**
     * @event refresh-attachment-list
     */
    close() {
      this.isVisible = false;
      this.storeUrl = null;
      this.model = null;

      eventBus.$emit('refresh-attachment-list');
    },

    /**
     * @return {undefined}
     */
    onStore() {
      this.isBusy = true;

      axios.post(this.storeUrl, this.getForm(), {})
          .then(({data: {message, model}}) => {
            _.isString(message) && this.$message.success(message);
            this.model = model;
          })
          .catch(this.handleErrorResponse)
          .then((isBusy = false) => {
            this.isBusy = isBusy;
          });
    },

    /**
     * @param {Object} response
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}) {
      const {errors, message} = data || {};
      if (status === 422 && errors) {
        this.errors = errors;
        this.$refs.form.validate(() => null);
        this.$message.error(message);
      } else if (message && _.isString(message)) {
        this.$message.error(message);
      }

      return false;
    },

    /**
     * @return {*}
     */
    getForm() {
      return _.assign({}, this.form, {_method: 'PATCH'});
    },
  },

  created() {
    eventBus.$on('show-attachment-form-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-attachment-form-dialog', this.show);
  },

  mixins: [
    ValidatorMixin,
  ],
}
</script>

<style scoped>

</style>
